import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import type { ChargeFetchParams } from "@/types/charge";
import { fetchChargeTable } from "@/api/provider/billing/charge";

// Query keys
export const chargesQueryKeys = {
  all: ["billing", "charges"] as const,
  list: (filters: ChargeFetchParams) => [...chargesQueryKeys.all, "list", filters] as const
};

// React Query hooks
export const useCharges = (filters, options) => {
  const $ = _c(8);
  let t0;
  if ($[0] !== filters) {
    t0 = chargesQueryKeys.list(filters);
    $[0] = filters;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== filters) {
    t1 = () => fetchChargeTable(filters);
    $[2] = filters;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = options?.enabled ?? true;
  let t3;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return useQuery(t3);
};

// Hook to get query client for invalidations
export const useInvalidateCharges = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      invalidateAll: () => queryClient.invalidateQueries({
        queryKey: chargesQueryKeys.all
      }),
      invalidateList: filters => queryClient.invalidateQueries({
        queryKey: chargesQueryKeys.list(filters)
      })
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};